import { App, Plugin, Route, View } from "@pimo/pimo-app-builder";
import {
  DragAndDropLayout,
  DragDropLayoutTabDefinition,
} from "@pimo/pimo-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";
import { generatePath } from "react-router-dom";

import { TestAppState } from "../../app";
import { APP_ROUTES, FINDINGS_TAB_ID } from "../../constants";
import { getReportDisplayTabs } from "../../helpers/pages-helpers/report-tab-titles";
import { addFindingsCards } from "./cards/findings";

export class FindingsPlugin implements Plugin<
  TestAppState,
  TestAppState,
  "id"
> {
  route?: Route<"id", TestAppState>;
  private view?: View<TestAppState, DragAndDropLayout>;
  private app?: App<TestAppState>;

  onRegister(app: App<TestAppState>): void {
    this.app = app;

    this.view = app.createView({
      name:
        getLocalizedMessage(app.getAppState().language || "en", "findings") ||
        "Findings",
      layout: new DragAndDropLayout(),
    });

    addFindingsCards(this.view);

    this.view.mapLayoutState(
      ({ reportLayout, settings, language, currentReport }) => {
        const stubTabs: DragDropLayoutTabDefinition[] = getReportDisplayTabs(
          reportLayout,
          settings?.configuration?.itemName,
          language || "en"
        ).map((tab) => ({ ...tab, rows: [] }));

        const findingsTitle =
          getLocalizedMessage(language || "en", "findings") || "Findings";

        const tabs: DragDropLayoutTabDefinition[] = [
          ...stubTabs,
          {
            id: FINDINGS_TAB_ID,
            title: findingsTitle,
            rows: [
              {
                id: 0,
                columnCount: 2,
                stackBreakpoint: "lg",
                columns: [
                  {
                    columnIndex: 0,
                    componentId: "riskHeatMapComponent",
                    flex: 2,
                  },
                  {
                    columnIndex: 1,
                    componentId: "criticalFindingComponent",
                    flex: 1,
                  },
                ],
              },
            ],
          },
        ];

        return {
          tabs,
          canEdit: false,
          displayTabs: true,
          language: language || "en",
          activeTabIndex: tabs.length - 1,
          onTabChange: (newIndex: number) => {
            if (tabs[newIndex]?.id === FINDINGS_TAB_ID) {
              return;
            }
            this.app?.navigate(
              generatePath(APP_ROUTES.report, {
                id: String(currentReport?.project?.id ?? ""),
                viewname: "dashboard",
              })
            );
          },
        };
      }
    );

    this.route = app.createRoute<"id">({
      path: APP_ROUTES.findings,
      view: this.view,
    });
  }

  getName() {
    return "findings-plugin";
  }
}

export default FindingsPlugin;
